import { MedicalLicenceNumber } from '@dreryk/medical-licence-number-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { MedicalLicenceNumberInput, StyledMaxWidth } from '@dreryk/react-components';

type PractitionerLicenceNumberFieldName = 'diagnosedByLicenceNumber' | 'removalDiagnosisByLicenceNumber';
type PractitionerLicenceNumberType = MedicalLicenceNumber | null;

export type PractitionerLicenceNumberFormBeanPart = {
   [key in PractitionerLicenceNumberFieldName]: PractitionerLicenceNumberType;
};

type PractitionerLicenceNumberProps<FIELD_NAME extends PractitionerLicenceNumberFieldName> = {
   readonly register: BindingCreator<PractitionerLicenceNumberFormBeanPart>;
   readonly name: FIELD_NAME;
   readonly label: string;
   readonly disabled?: boolean;
};

export const PractitionerLicenceNumber = <FIELD_NAME extends PractitionerLicenceNumberFieldName>(
   props: PractitionerLicenceNumberProps<FIELD_NAME>
): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={92}>
         <MedicalLicenceNumberInput
            controller={props.register(props.name, { required: true })}
            testId={props.name}
            label={props.label}
            disabled={props.disabled}
         />
      </StyledMaxWidth>
   );
};
